<nav class="toolbar navbar navbar-light">
    <div class="form-inline">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar || formInvalid" type="button" class="btn btn-outline-success" title="Guardar" (click)="onClickSave()"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </div>
</nav>

<div class="animated fadeIn container-fluid">
    <h4 style="display:inline">{{title}} documento, Solicitud: {{solicitudLaboratorio?.CodigoSolicitud}}</h4>
    <h5 style="display:inline; margin-left: 8px">
        <span>
            <!--***ICONOS***-->
            <img class="estado-icono-big" container="body" src="{{idTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
            <img class="estado-icono-big" container="body" src="{{solicitudLaboratorio?.IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{solicitudLaboratorio?.IdEstadoSolicitudDescripcion}}" />
            <img *ngIf="solicitudLaboratorio?.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{solicitudLaboratorio?.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{solicitudLaboratorio?.IdEstadoChedPpDescripcion}}" />
            <img *ngIf="solicitudLaboratorio?.IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{solicitudLaboratorio?.IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudLaboratorio?.DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
            <img class="predua-icono-big" container="body" ngbTooltip="{{solicitudLaboratorio?.EsPredua | preduaNoPredua}}" src="{{solicitudLaboratorio?.EsPredua | IconoPreduaSolicitud}}" />
            <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
            <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
        </span>
    </h5>

    <div [formGroup]="form">

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Nuevo documento
                            <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-header">
                        <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label class="col-form-label" for="inpTexto">Descripción</label>
                                    <input [readonly]="!esPerfilConsultasyLaboratorio || envioMuestrasCerrado" formControlName="Texto" name="Texto" title="" class="form-control" inputStyleClass="form-control" id="inpTexto" type="text" value="" maxlength="200">
                                </div>
                            </div>

                            <div *ngIf="esPerfilConsultasyLaboratorio && !envioMuestrasCerrado" class="row">
                                <div class="form-group col-md-12">
                                    <label class="col-form-label required-field" for="intEstado">Documento</label>

                                    <app-document-uploader *ngIf="uploadedFile" [parentForm]="form" [parentSubmitted]="submitted" [megaSizeLimit]="megaSizeLimit" [uploadedFile]="uploadedFile" (fileUploaded)="onFileUploaded($event)" [documentModule]="documentModuleLaboratorio" (fileDeleted)="onFileDeleted($event)">
                                    </app-document-uploader>

                                </div>
                            </div>

                            <div *ngIf="!esPerfilConsultasyLaboratorio || envioMuestrasCerrado" class="row">
                                <div class="form-group col-md-12">
                                    <label class="col-form-label required-field" for="intEstado">Documento</label>

                                    <app-document-uploader *ngIf="uploadedFile" [parentForm]="form" [parentSubmitted]="submitted" [megaSizeLimit]="megaSizeLimit" [uploadedFile]="uploadedFile" (fileUploaded)="onFileUploaded($event)" [documentModule]="documentModuleLaboratorio" [readOnly]="true" [readOnlyDownload]="true" (fileDeleted)="onFileDeleted($event)">
                                    </app-document-uploader>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
